import { ChevronRight as IconChevronRight } from "@mui/icons-material";
import { darken, Stack, Typography } from "@mui/material";
import { Link, To } from "react-router";

import { StatusCheckmark } from "~/modules/app/components/StatusCheckmark";

type ProjectReviewVisitV2OverviewNavigationItemProps = {
    checked?: boolean;
    label: string;
    to: To;
};

export function ProjectReviewVisitV2OverviewNavigationItem({
    checked,
    label,
    to,
}: ProjectReviewVisitV2OverviewNavigationItemProps) {
    return (
        <Stack
            component={Link}
            direction="row"
            alignItems="center"
            padding={2}
            columnGap={2}
            to={to}
            sx={theme => ({
                textDecoration: "none",
                color: theme.palette.text.primary,
                borderBottom: `1px solid ${theme.palette.divider}`,
                "&:hover": {
                    backgroundColor: darken(theme.palette.background.paper, 0.03),
                },
            })}
        >
            {checked !== undefined && <StatusCheckmark checked={checked} />}
            <Stack flexGrow={1}>
                <Typography>{label}</Typography>
            </Stack>
            <IconChevronRight />
        </Stack>
    );
}
